/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const profile = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.434 3.754c2.095 1.974 4.935 3.088 7.9 3.1 1.505 0 2.995-.291 4.377-.853M10.2 11.118c-1.215 1.143-3.185 1.143-4.4 0m7.15-8.068a7 7 0 1 1-9.9 9.9 7 7 0 0 1 9.9-9.9Z"
    />
  </svg>
)
export default profile
